import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Column } from 'react-table'
import Table from '../../../../../../global/components/table/Table'
import TableTopper from '../../../../../../global/components/table/helpers/table-topper/TableTopper'
import TableTitle from '../../../../../../global/components/table/helpers/table-title/TableTitle'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { getOrderHistoryById, getOrderServicesById } from '../../../../api'
import { fetchData } from '../../../../../../global/utils/fetch'
import {
  IOrderHistory,
  OrderHistory,
} from '../../../../../../../../app/entities/OrderHistory'
import {
  DELIVERY_STATUSES_MAP,
  STATUSES,
} from '../../../../../../global/constants/order-status'
import { IOrderService } from '../../../../../../../../app/entities/OrderService'
import isDeliveryByOrderService from '../../../../../../global/utils/is-delivery-by-order-service'
interface IWorkOrderHistoryTableStateProps {
  data: IOrderHistory[]
  isLoading: boolean
}
export default function WorkOrderHistoryEntriesTable() {
  const { id: orderObjectId } = useParams()
  const { user } = useAuthenticator((context) => [context.user])
  const [tableState, setTableState] =
    useState<IWorkOrderHistoryTableStateProps>({
      data: [],
      isLoading: false,
    })
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const fetchTableData = async () => {
      setTableState((prevState) => ({
        ...prevState,
        isLoading: true,
      }))
      const data = await fetchData<{
        items: IOrderHistory[]
        count: number
      }>(getOrderHistoryById(orderObjectId))
      const orderServices = await fetchData<IOrderService[]>(
        getOrderServicesById(orderObjectId),
      )

      // Sort the histories oldest -> newest and rename the subsequent 'scheduled's -> 'rescheduled'
      data.items.sort((a, b) => a.created - b.created)
      const firstScheduledHistoryIdx = data.items.findIndex(
        (item) => item.status === STATUSES.scheduled,
      )
      const isDelivery = isDeliveryByOrderService(orderServices || [])

      if (isDelivery) {
        // for delivery orders, filter out duplicate consecutive statuses
        const filteredItems: IOrderHistory[] = []
        data.items.forEach((currentItem, idx) => {
          const mappedStatus =
            DELIVERY_STATUSES_MAP[currentItem.status || ''] ||
            currentItem.status
          currentItem.status = mappedStatus
          if (idx === 0) {
            filteredItems.push(currentItem)
          } else {
            const previousItem = filteredItems[filteredItems.length - 1]
            const previousStatus = previousItem.status
            if (mappedStatus !== previousStatus) {
              filteredItems.push(currentItem)
            }
          }
        })

        data.items = filteredItems
      } else {
        // For non-delivery orders, keep the original logic
        data.items.forEach((item, idx) => {
          if (
            item.status === STATUSES.scheduled &&
            idx !== firstScheduledHistoryIdx
          ) {
            item.status = STATUSES.rescheduled
          }
        })
      }

      // Put the most recent history on top
      data.items = data.items.reverse()

      setTableState((prevState) => ({
        ...prevState,
        data: data.items,
        isLoading: false,
      }))
    }

    if (isOpen) {
      fetchTableData()
    }
  }, [isOpen, orderObjectId, user])

  const columns: Column<OrderHistory>[] = [
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: 'Created',
      accessor: 'created',
      Cell: ({ value }) => {
        return (
          value
            ? `${new Date(value).toLocaleTimeString()} ${new Date(
                value,
              ).toLocaleDateString()}`
            : 'N/A'
        ) as any
      },
    },
    {
      Header: 'Updated',
      accessor: 'updated',
      Cell: ({ value }) => {
        return (
          value
            ? `${new Date(value).toLocaleTimeString()} ${new Date(
                value,
              ).toLocaleDateString()}`
            : 'N/A'
        ) as any
      },
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Work Order History Entries </TableTitle>
        </div>
      </TableTopper>
      <Table
        columns={columns}
        data={tableState.data as any}
        isLoading={tableState.isLoading}
        onRowClick={console.log}
        isOpen={isOpen}
        isDisplayMode={true}
      />
    </div>
  )
}
